import React from 'react'

interface ChatProps {
  handleChatClick: () => void
}

const Chat: React.FC<ChatProps> = ({ handleChatClick }) => {
  return (
    <div className="fixed top-0 right-0 w-[400px] h-full bg-white shadow-lg border-l border-gray-200 z-50">
      <div className="flex flex-col h-full">
        {/* Chat Header */}
        <div className="flex items-center justify-between px-4 py-2 border-b border-gray-200">
          <h3 className="text-lg font-semibold">Relationship to Student</h3>
          <button
            className="text-gray-500 hover:text-gray-700"
            onClick={handleChatClick}
          >
            &times;
          </button>
        </div>

        {/* Chat Content */}
        <div className="flex-1 overflow-y-auto p-4">
          <div className="space-y-4">
            <div className="bg-primary-100 text-primary-800 p-3 rounded-lg">
              Hello, how can I assist you with this task?
            </div>
            <div className="bg-gray-100 text-gray-800 p-3 rounded-lg self-end">
              I need more details about the relationship issue.
            </div>
          </div>
        </div>

        {/* Chat Input */}
        <div className="border-t border-gray-200 p-4">
          <input
            type="text"
            placeholder="Enter a message"
            className="w-full border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-primary-500"
          />
        </div>
      </div>
    </div>
  )
}
export default Chat
